import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ZeroStateComponent } from "../zero-state/zero-state.component";

@Component({
    selector: 'app-unauthorized',
    imports: [ZeroStateComponent],
    templateUrl: './unauthorized.component.html',
    styleUrl: './unauthorized.component.scss'
})
export class UnauthorizedComponent {
  public lastRouteBeforeReRouteList: string[] = [];

  constructor(private router: Router) {}

  public ngAfterViewInit(): void {
    const json = localStorage.getItem('lastRouteBeforeReRouteList')?.toString();
    if (json) {
      this.lastRouteBeforeReRouteList = JSON.parse(json);
      if (this.lastRouteBeforeReRouteList[0] === '/') {
        this.lastRouteBeforeReRouteList.splice(0, 1);
      }
    }
  }

  public handleClick(): void {
    localStorage.removeItem('lastRouteBeforeReRouteList');
    this.router.navigate([this.lastRouteBeforeReRouteList[1] ?? '/directory']);
  }
}
